module.exports = __webpack_public_path__ + "img/3.63f9e1dc.jpg";